/** @format */

import { Component, Inject, Input } from '@angular/core';
import { WINDOW } from '@shared/utils/services';

@Component({
    selector: 'pdp-add-to-cart-component-fulfillment-button',
    templateUrl: './fulfillment-button.component.html',
    styleUrls: ['./fulfillment-button.component.scss'],
    standalone: false
})
export class PdpFulfillmentButtonComponent {
	@Input() isSelected = false;

	@Input() isDisabled = false;

	constructor(@Inject(WINDOW) protected window: Window) {}
}
